import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginForm } from '@/features/auth'
import { authTokenStore } from '@/shared/api'
import { Icon } from '@/shared/ui/icon'

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (authTokenStore.getState().token) throw redirect({ to: '/' })
  },
  component: LoginPage,
})

function LoginPage() {
  return (
    <div className="w-full max-w-sm rounded-panel bg-panel p-8">
      <div className="mb-6 flex flex-col items-center gap-3 text-center">
        <span className="flex size-14 items-center justify-center rounded-card bg-grad-tile text-white">
          <Icon name="phone-call" size={26} />
        </span>
        <div>
          <h1 className="text-heading-lg font-light">Caller Engine</h1>
          <p className="mt-1 text-body-sm text-muted">Админка оператора инсталляции</p>
        </div>
      </div>
      <LoginForm />
    </div>
  )
}
